import { render, staticRenderFns } from "./communityArticleInclude.vue?vue&type=template&id=4e43c9ff&scoped=true"
import script from "./communityArticleInclude.vue?vue&type=script&lang=js"
export * from "./communityArticleInclude.vue?vue&type=script&lang=js"
import style0 from "./communityArticleInclude.vue?vue&type=style&index=0&id=4e43c9ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e43c9ff",
  null
  
)

export default component.exports